import SearchIcon from 'modules/cp_membersAndPermissions/assets/icons/SearchIcon';

import style from './style.module.css';

//Todo: remove any
const HeaderSearchIcon = () => {
  return (
    <div className={style.HeaderSearchIcon}>
      <SearchIcon />
    </div>
  );
};

export default HeaderSearchIcon;
